const brand = "MANAGE MESSAGES";
const baseUrl = "http://localhost:3000";

const baseUrlApi = "http://localhost:3000/api";

export const config = {
  brand,
  baseUrl,
  baseUrlApi,
  defaultUserImage:
    "https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg",
  email: "hola@managemessages.com",
  phone: "+1 (123) 456-7890",
  address: "USA",
  whatsappNumber: "5491158888423",
  facebook: "",
  twitter: "",
  instagram: "",
  socialMedia: {
    facebook: "",
    twitter: "",
    instagram: "",
    linkedin: "",
  },
  theme: {
    logo: "/logo-manage-messages.svg",
    brandLogo: "logo-manage-messages.svg",
    colors: {
      primaryColor: "#8B5CF6",
      secondaryColor: "#3B82F6",
      tertiaryColor: "#10B981",
      quaternaryColor: "#9013FE",
      textMenuColor: "#FFFFFF",
      textMenuHoverColor: "#FFFFFF",
      textMenuBrandColor: "#FFFFFF",
    },
  },
};
